import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_Dashboard_CustomerParticipantDashboardResponseDto,
} from '../../services/wealthlane-customer-services';

const useGetCustomerParticipantDashboardDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_Dashboard_CustomerParticipantDashboardResponseDto | undefined,
  unknown
> => {
  const customerParticipantDashboardDetails = useQuery(
    ['getCustomerParticipantDashboardDetails'],
    async () => {
      return await handleRequest(
        DashboardService.getApiCustomerApiAppDashboardParticipantDashboard()
      );
    }
  );

  return customerParticipantDashboardDetails;
};

export default useGetCustomerParticipantDashboardDetails;
